define('responsive-gameday/controllers/BoxscoreViewController',['require','exports','module','Responsive/controllers/ScrollViewController','message-service/message-service','../views/distributors/events/DistributionEvents','../views/Monitor/Events/ViewModelUpdateEvents','gameday-index-url-hasher/enums/HashEvents','responsive-gameday-tracking/responsive-gameday-tracking','./LinescoreViewController','Responsive/util/renderComplete','Responsive/util/array','extant/extant','disk-storage/disk-storage','../views/render/BoxscoreViewRender'],function(require,exports,module) {
	// Add private variables here
	var ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        MessageService = require("message-service/message-service"),
		DistEvents = require("../views/distributors/events/DistributionEvents"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        HashEvents = require("gameday-index-url-hasher/enums/HashEvents"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        LinescoreViewController = require("./LinescoreViewController"),
        renderComplete = require("Responsive/util/renderComplete"),
        array = require("Responsive/util/array"),
        exists = require("extant/extant"),
        diskStorage = require("disk-storage/disk-storage"),
        BoxscoreViewRender = require( '../views/render/BoxscoreViewRender' );

	var Superclass,
		templates,
		mainRender;

	// Add private methods here
	// Constructor
	function BoxscoreViewController() {
		Superclass.constructor.call(this);
		this.referenceName = "boxscore";
		this.autoSelectTab = true;
		this.activeClassName = "active";
		this.viewRender = new BoxscoreViewRender();
		this.showLinescore = true;

        MessageService.publish("registerViewComponent", this);
	}

	// Prototype Inheritence
    ScrollViewController.spawn(BoxscoreViewController).define({
		loadView: function () {
			var that = this;

			Superclass.loadView.call(this);
			this.content = null;
			/*
			 * Click events for switching between teams on boxscore tab.
			 */
			$(this.getView()).on('click', 'nav.secondary li[data-view]', function (e) {
				var el = this;
				$(el).siblings().removeClass(that.activeClassName).end().addClass(that.activeClassName);
				e.preventDefault();
				e.stopPropagation();

				that.viewRender.viewState.activeTab = ~~el.getAttribute('data-view');
				that.content.setAttribute('data-view', that.viewRender.viewState.activeTab);

				// set new scroll when content switches.
				that.setScroll(that.getView().querySelector('.iscroll-container'));

				that.autoSelectTab = false;
				Tracking.track_box_anchor_activity();
			});

			// only attach toggle click listener if game is live
			if(!$(this.view).hasClass('wide-view')) {
				$(this.getView()).on('click', '.avgops', function (e) {
					// No ops data available? ignore clicks
					if($(that.getView()).find('.avgops-table').hasClass('no-ops')) {
						return;
					}
					//hide currently visible stat column and save new column as user-saved to local storage
					that.viewRender.handleAvgOps(this);
				});
			}
		},

		draw: function () {
			Superclass.draw.call(this);
			this.setClassName("BoxscoreViewController");
			this.showOverlay();
		},

		viewWillAppear: function () {
			var that = this;

			Tracking.track_box_tab_activity();

			Superclass.viewWillAppear.call(this);
            
			if (this.onBeat) {
				MessageService.removeListener.call(this, VMEvents.UPDATE_BOXSCORE, this.onBeat);
			}

			this.onBeat = function (payload, evt) {
				var view = this.childWrapper;
                that.drawBoxscore(payload);
			};
		},

		viewDidAppear : function(){
			Superclass.viewDidAppear.call(this);
			MessageService.addListener.call(this, VMEvents.UPDATE_BOXSCORE, this.onBeat);
			MessageService.publish(VMEvents.REQUEST_BOX_DATA);
		},

		drawBoxscore: function (data) {
			// console.log(data);
            var that = this,
				view = that.childWrapper,
                currentHalf,
				oldTab;

			if (!view) { return; }

			if (data.isNewHalfInning || this.autoSelectTab || that.viewRender.viewState.activeTab === undefined ) {
				that.viewRender.viewState.activeTab = data.isHomeBatting ? 1 : 0;
			}
			if (!view || !exists(data, "linescore.inning_line_score")) { return; }

			that.inningCount = data.linescore.inning_line_score.length;
            inning = data.linescore && (data.linescore.inning_line_score = array.ensureArray(data.linescore.inning_line_score)) || [];
			inningCount = inning.length;
			that.currentHalf = (data.isHomeBatting) ? "home" : "away";
			that.active = that.currentHalf === "away" ? 0 : 1;
			that.defaultSwitch = false;

			that.viewRender.viewState.avgops = data.hasOPS ? diskStorage.get('gameday', 'boxscore.selectedavgops').value || 'avgops-avg' : 'avgops-avg';

			// Used for extra arrow td's in template
			LinescoreViewController.embeddedHelper(that, data.linescore);

			this.viewRender.viewState.showLinescore = this.showLinescore;

			view.innerHTML = this.viewRender.render(data);			

			renderComplete(function () {
				that.content = that.getView().querySelector('#boxscore');
				that.setScroll(that.getView().querySelector('.iscroll-container'));
				
				that.hideOverlay();
				LinescoreViewController.setEmbeddableScrollBar(that, data.linescore)
                LinescoreViewController.embeddeScrollerdHelper(that, data.linescore);
			});
		},

		viewWillDisappear: function () {
			var that = this;
			this.defaultSwitch = true;
			if (this.onBeat) {
				MessageService.removeListener(VMEvents.UPDATE_BOXSCORE, this.onBeat);
				MessageService.removeListener(HashEvents.GAME_ID_CHANGED, function () {
					that.defaultSwitch = true;
					that.autoSelectTab = true;
				});
			}

			Superclass.viewWillDisappear.call(this);
		}
	});

	Superclass = BoxscoreViewController.superclass;
    return BoxscoreViewController;
});
